import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LEFT_IMG from '../../assets/images/sitemap_logo.png';

const Sitemap = () => {
  const navigate = useNavigate();

  const close = () => navigate(-1);
  const go = (path) => () => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  const goBoard = (cat) => () => {
    navigate(`/board/${cat}`);
    window.scrollTo(0, 0);
  };
  const goProduct = (tab) => () => {
    navigate(`/board/product/${tab}`);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    // 스크롤 잠금 + 헤더 숨김
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('sitemap-open');

    const onEsc = (e) => e.key === 'Escape' && close();
    window.addEventListener('keydown', onEsc);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.classList.remove('sitemap-open');
      window.removeEventListener('keydown', onEsc);
    };
  }, []); // mount/unmount

  return (
    <div className="sitemap-overlay" role="dialog" aria-modal="true">
      {/* 전체 흰 배경(헤더 포함 전부 덮기) */}
      <div className="sitemap-blanket" onClick={close} />

      {/* 컨텐츠 영역 */}
      <button className="sitemap-close" aria-label="닫기" onClick={close}>
        ✕
      </button>

      <div className="sitemap-grid">
        {/* 좌측 이미지 */}
        <div
          className="sitemap-visual"
          onClick={() => {
            navigate('/');
            window.scrollTo(0, 0);
          }}
          style={{ cursor: 'pointer' }} // 👈 클릭 가능한 느낌 추가
        >
          <img src={LEFT_IMG} alt="MEDICODE 로고" />
        </div>

        {/* 우측 3열 + 구분선 */}
        <div className="sitemap-columns">
          <div className="sitemap-col">
            <h3>기업소개</h3>
            <ul>
              <li onClick={go('/medicode')}>회사소개</li>
            </ul>

            <h3 style={{ marginTop: 28 }}>상품</h3>
            <ul>
              <li onClick={goProduct('1')}>건강검진</li>
              {/* <li onClick={goProduct('2')}>뷰티(줄기세포)</li>
              <li onClick={goProduct('3')}>항노화(줄기세포)</li> */}
            </ul>
          </div>

          <div className="sitemap-divider" />

          <div className="sitemap-col">
            <h3>협력업체</h3>
            <ul>
              <li onClick={goBoard('partnership')}>협력업체</li>
            </ul>

            <h3 style={{ marginTop: 28 }}>기타</h3>
            <ul>
              <li onClick={goBoard('contact_us')} className="strong">
                CONTACT US
              </li>
            </ul>
          </div>

          <div className="sitemap-divider" />

          <div className="sitemap-col">
            <h3>미디어</h3>
            <ul>
              <li onClick={goBoard('news')}>뉴스룸</li>
            </ul>
          </div>
        </div>
      </div>

      {/* 워터마크(연한 회색) */}
      <div className="sitemap-watermark" aria-hidden="true">
        MEDICODE
      </div>
    </div>
  );
};

export default Sitemap;
